import z from 'zod'
import { nullSafeBoolean, nullSafeOptionalString } from '../shared/schema'

export const schema = z.object({
  breakoutAppUrl: nullSafeOptionalString(),
  // When true, the Adonis worker sends its LMS API calls through the LTI
  // proxy so they leave from the stable LTI egress IP.
  useLtiProxy: nullSafeBoolean(false),
})

export const empty = Object.freeze(
  schema.parse({
    breakoutAppUrl: undefined,
  })
)

export type FirestoreSettingsLti = z.infer<typeof schema>
